
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/match-booster/enable-in-syncs",
      function () {
        return require("private-next-pages/match-booster/enable-in-syncs.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/match-booster/enable-in-syncs"])
      });
    }
  